import './Home.css'
import ADD from "../images/add5.jpg"
import ADD2 from "../images/ADD2.jpg"
import ADD3 from "../images/ADD3.jpg"
import ADD4 from "../images/ADD4.jpg"
import Offer from "../images/offer6.jpg"
import Offer2 from "../images/offer2.jpg"
import Offer3 from "../images/offer3.jpg"
import Offer4 from "../images/offer4.jpg"
import Offer5 from "../images/offer5.jpg"
//decors home
import Decor1 from "../images/decor1.jpg"
import Decor2 from "../images/decor2.jpg"
import Decor3 from "../images/decor3.jpg"
import Decor4 from "../images/decor4.jpg"
//fashion
import Fashion1 from "../images/fashion1.jpg"
import Fashion2 from "../images/fashion2.jpg"
import Fashion3 from "../images/fashion3.jpg"
import Fashion4 from "../images/fashion4.jpg"

//women
import Women1 from '../images/women1.jpg'
import Women2 from '../images/women2.jpg'
import Women3 from '../images/women3.jpg'
import Women4 from '../images/women4.jpg'
import Mask from '../images/Mask.jpg'
//electronic devices
import Elec1 from '../images/elec1.jpg'
import Elec2 from '../images/elec2.jpg'
import Elec3 from '../images/elec3.jpg'
import Elec4 from '../images/elec4.jpg'
import Pc from "../images/pc.jpg"
import Alexa from "../images/alexa.jpg"
import Chimney from "../images/chimney.jpg"
import Video from "../images/video.mp4"
//column colls
import Col1 from "../images/col1.jpg"
import Col2 from "../images/col2.jpg"
import Col3 from "../images/col3.jpg"
import Col4 from "../images/col4.jpg"
import chim7 from "../images/chim5.webp"

import ShoppingCart from '@material-ui/icons/ShoppingCart'
import { Link } from 'react-router-dom'


function Home() {
    return (

        <div className="color">

            <div>
                <div className="adds"><img src={ADD} /></div>
              



                <div className="decorflex">

                    <div className="decor1">
                        <div className="decorlayout">
                            <p><strong>Revamp your home in style</strong></p>
                            <div className="decor1">
                                <Link to="/decor"><p><img className="decor" src={Decor1} /></p></Link>
                                <Link to="/frame"><p><img className="decor" src={Decor2} /></p></Link>
                            </div>
                            <div className="decor1">
                                <Link to="/rack"><p><img className="decor" src={Decor3} /></p></Link>
                                <Link to="/lamp"><p><img className="decor" src={Decor4} /></p></Link>
                            </div>
                            <p>see more</p>

                        </div>
                    </div>


                    <div className="decor1">
                        <div className="decorlayout">
                            <p><strong>Styles for Men | Up to 70% off</strong></p>
                            <div className="decor1">
                                <Link to="/men"><p><img className="decor" src={Fashion1} /></p></Link>
                                <Link to="/shoes"><p><img className="decor" src={Fashion2} /></p></Link>
                            </div>
                            <div className="decor1">
                                <Link to="/watches"><p><img className="decor" src={Fashion3} /></p></Link>
                                <Link to="/bag"><p><img className="decor" src={Fashion4} /></p></Link>

                            </div>
                            <p>see more</p>

                        </div>
                    </div>

                    <div className="decor1">
                        <div className="decorlayout">
                            <p><strong>Styles for Women | Up to 70% off</strong></p>
                            <div className="decor1">
                                <Link to="/dress"><p><img className="decor" src={Women1} /></p></Link>
                                <Link to="/handbag"><p><img className="decor" src={Women2} /></p></Link>
                            </div>
                            <div className="decor1">
                                <Link to="/watches1"><p><img className="decor" src={Women3} /></p></Link>
                                <Link to="/earring"><p><img className="decor" src={Women4} /></p></Link>

                            </div>
                            <p>see more</p>

                        </div>

                    </div>
                </div>
            </div>

            <div>
                <div className="decorflex">

                    <div className="decor1">
                        <div className="decorlayout1">
                            <p><strong>Top picks for your home</strong></p>
                            <div className="decor1">
                                <Link to="/ac"> <p><img className="decor" src={Elec1} /></p></Link>
                                <Link to="/fridge"> <p><img className="decor" src={Elec2} /></p></Link>
                            </div>
                            <div className="decor1">
                                <Link to="/mw"> <p><img className="decor" src={Elec3} /></p></Link>
                                <Link to="/wm"> <p><img className="decor" src={Elec4} /></p></Link>

                            </div>
                            <p>see more</p>

                        </div>
                    </div>


                    <div className="decor1">
                        <div className="decorlayout1">
                            <p><strong>Up to 70% off | Electronics clearance store</strong></p>
                            <div className="decor1">
                                <Link to="/Order"><p><img className="color1" src={Pc} /></p></Link>

                            </div>

                            <p>see more</p>

                        </div>
                    </div>

                    <div className="decor1">
                        <div className="decorlayout1">
                            <p><strong>Echo dot smart bulb combo | Just ask Alexa</strong></p>
                            <div className="decor1">
                                <Link to="/alexa"><p><img className="color1" src={Alexa} /></p></Link>

                            </div>

                            <p>see more</p>

                        </div>

                    </div>
                </div>
            </div>






            <div>
                <div className="decorflex">

                    <div className="decor1">
                        <div className="decorlayout1">
                            <p><strong>Top picks for your home</strong></p>
                            <div className="decor1">
                                <Link to="/mi"><p><img className="decor" src={Col1} /></p></Link>
                                <Link to="/ci"><p><img className="decor" src={Col2} /></p></Link>
                            </div>
                            <div className="decor1">
                                <Link to="/di"><p><img className="decor" src={Col3} /></p></Link>
                                <Link to="/ei"><p><img className="decor" src={Col4} /></p></Link>

                            </div>
                            <p>see more</p>

                        </div>
                    </div>


                    <div className="decor1">
                        <div className="decorlayout1">
                            <p><strong>Smart Phones</strong></p>
                            <div className="decor1">
                                <Link to="/mobile"><p><img className="color5" src={Mask} /></p></Link>

                            </div>

                            <p>see more</p>

                        </div>
                    </div>

                    <div className="decor1">
                        <div className="decorlayout1">
                            <p><strong>Home essentials | Amazon Brands & more</strong></p>
                            <div className="decor1">
                                <Link to="/chim"><p><img className="color1" src={chim7} /></p></Link>

                            </div>

                            <p>see more</p>

                        </div>

                    </div>
                </div>
            </div>


        </div>



    )
}
export default Home;